import * as curatorLight from '../../../../redux/slicers/admin/curatorLightSlicer';

import {
  AXIS,
  CHANGED_MAP_IDS__TEXTURE_MAP,
  CURSOR_MODE,
  TEXTURE_MAP_TO_TILING_TYPE,
  TEXTURE_NAME_KEY,
  TEXTURE_NAME_KEY__TEXTURE_MAP,
  TILING_MAP,
  TRANSFORM_SPACE_MODE,
  UNITY_2D_VIEW_MODE,
} from '../../../../config/constant/unityConstants';
import { Mixpanel, MxEvent } from '../../../../common/Mixpanel';
import {
  SAVE_PROJECT_MODE,
  curatorActions,
  curatorSelector,
  selectAxisAvailability,
  selectCuratorInitialized,
  selectCursorMode,
  selectIs2DMode,
  selectIs3DMode,
  selectIsStyleOnlyMode,
  selectMeasureUnit,
  selectProjectLoadedTexture,
  selectProjectOwner,
  selectSelectedAxis,
  selectSidebarSection,
  selectTransformSpaceMode,
  setClickedUpdateConfigurator,
  setCuratorLoader,
  setCursorMode,
  setSaveProjectDialogOpen,
  setSaveProjectMode,
  setSidebarSection,
  setUnity2DViewMode,
  toggleDimension,
} from '../../../../redux/slicers/admin/curatorSlicer';
import {
  TAB_NAME,
  curatorStylesSelector,
  selectApplyTextureInProgress,
  selectIsSelectMapModeActive,
  setActiveTab,
} from '../../../../redux/slicers/admin/curatorStylesSlicer';
import { UnityEvent, waitForEventOnce } from '../../../../helpers/unityPubSub';
import {
  apiAddDefaultTexture,
  apiGetDefaultTexture,
  apiGetTextureList,
} from '../../../../helpers/api';
import {
  canChangeSelectedAxis,
  clearUI,
  closeSidebar,
  openSidebarSection,
  toggleSidebarSection,
  validateStyleable,
} from '../../../../helpers/curatorActions';
import { checkIfMemberHaveEditorAccess, useUserContext } from '../../../../contexts/UserContext';
import {
  curatorSnappingActions,
  selectRotationSnappingActive,
  selectRotationSnappingValue,
} from '../../../../redux/slicers/admin/curatorSnappingSlicer';
import { errorToast, infoToast, successToast, warningToast } from '../../../../helpers/toastHelper';
import {
  getDefaultTextureFromIdb,
  useLoadDefaultTextures,
} from '../stylesSection/PropertiesTab/useGetDefaultObjectMaps';
import {
  resetObjectPositionAlongAxis,
  selectAllSelectedObjectsStyleable,
  selectCanCopyMaterial,
  selectCanDuplicateSelectedObjects,
  selectCanReplaceProp,
  selectCopiedObjectProperties,
  selectHasSelectedObjectInfo,
  selectIsAnyObjectSelected,
  selectIsOneObjectSelected,
  selectIsSingleLightObjectSelected,
  selectIsStyleableObject,
  selectReplaceProp,
  selectSelectedLightObject,
  selectSelectedObjectList,
  setCopiedObjectProperties,
  setDuplicatePropInProgress,
  selectIsConfiguratorPropSelected,
  setShowInfoWarningPopup,
  setInfoWarningPopupMessage,
} from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import {
  selectCameraSafeModeEnabled,
  selectGridViewEnabled,
  setGlobalSafeCameraFlag,
  setGridViewFlag,
} from '../../../../redux/slicers/camera/cameraSettings';
import {
  selectHighlightSelected,
  selectIsMaterialCopied,
  selectLightsVisibility,
  selectPopupOpen,
  selectReplaceGroupPropActive,
  selectReplacePropActive,
  selectShowDimensions,
  setHighlightSelected,
  setLightsVisibility,
  setMaterialCopied,
  setPopupOpen,
  setReplacePropActive,
  setShowDimensions,
} from '../../../../redux/slicers/admin/shortcutsModuleSlicer';
//import { captureException } from '@sentry/react';
import { useDispatch, useSelector } from 'react-redux';

import { CURATOR_MENU_SECTION } from '../../../../redux/slicers/admin/curatorMenuPreferencesSlicer';
import { getAppState } from '../../../../redux/store';
import { getMattressBuilderPath, getProjectsPath } from '../../../../helpers/urlHelper';
import { isUserOnboarding } from '../../../gamificationTooltip/helpers';
import { paginatedProductActions } from '../../../../redux/slicers/admin/paginatedProductSlicer';
import { selectGamificationTooltipData } from '../../../../redux/slicers/gamificationTooltipSlicer';
import { setCuratorNotSaved } from '../../../../pages/admin/curator/curatorState';
import {
  selectPasteMaterialLoading,
  setPasteMaterialLoading,
} from '../../../../redux/slicers/admin/curatorLoaderSlicer';
import { undoRedo } from '../UndoRedo/UndoRedo';
import { updateDbTexture } from '../../../../helpers/idb';
import { useInfoDialogaActions } from '../../../../hooks/useInfoDialogaActions';
import { useMapSelection } from '../stylesSection/useMapSelection';
import { useNavigate, useParams } from 'react-router-dom';
import { useRenderPreviewPopup } from '../../../../hooks/useRenderPreviewPopup';
import { useSaveProject } from './useSaveProject';
import { useUnityContext } from '../../../container/unityContainer';
import { wait } from '../../../../helpers/jsHelper';
import { fetchAllPages } from '../../../../helpers/apiHelper';
import { isAlignDialogOpen, isRetailAutomation } from '../../../Configurator/utils';
import { STATUS_DONE_VALUE, STATUS_START_VALUE } from '../../../../constants/supportConstants';
import {
  initiateProductBuilderProgressLoading,
  isMattressBuilderPage,
} from '../ProductBuilderComponents/commonHelper';

export const useUnityShortcuts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const unityContext = useUnityContext();
  const { openInfoDialog } = useInfoDialogaActions();
  const renderPreviewPopup = useRenderPreviewPopup();
  const loadDefaultTextures = useLoadDefaultTextures();
  const { currentUser, isGuestLogin } = useUserContext();
  const { cancelMapSelection } = useMapSelection();
  const saveProjectActions = useSaveProject();
  const gamificationTooltipData = useSelector(selectGamificationTooltipData);
  const { step } = gamificationTooltipData;
  const { type } = useParams();

  const getRequiredState = () => {
    const appState = getAppState();
    const anyObjectSelected = selectIsAnyObjectSelected(appState);
    const isOnlyOneObjectSelected = selectIsOneObjectSelected(appState);
    const hasSelectedObjectInfo = selectHasSelectedObjectInfo(appState);
    const isStyleableObject = selectIsStyleableObject(appState);

    return {
      anyObjectSelected,
      isOnlyOneObjectSelected,
      hasSelectedObjectInfo,
      isStyleableObject,
    };
  };

  const resetData = () => {
    dispatch(curatorActions.toggleSelectedAxis(AXIS.ALL));
    // dispatch(curatorActions.setTransformSpaceMode(TRANSFORM_SPACE_MODE.GLOBAL));
    dispatch(resetObjectPositionAlongAxis());
  };

  const changeCursorMode = (cursorMode) => {
    const currentCursorMode = selectCursorMode(getAppState());

    if (currentCursorMode === CURSOR_MODE.STYLE_ONLY) {
      unityContext.shortcutsModule.StyleOnlyReceiver(false);
    }

    dispatch(setCursorMode(cursorMode));
    resetData();

    switch (cursorMode) {
      case CURSOR_MODE.MOVE:
        Mixpanel.track(true, MxEvent.CURATOR_MOVE_SELECTED);
        unityContext.shortcutsModule.TransformTypeMoveReceiver();
        break;
      case CURSOR_MODE.ROTATE:
        Mixpanel.track(true, MxEvent.CURATOR_ROTATE_SELECTED);
        unityContext.shortcutsModule.TransformTypeRotateReceiver();
        break;
      case CURSOR_MODE.SCALE:
        Mixpanel.track(true, MxEvent.CURATOR_SCALE_SELECTED);
        unityContext.shortcutsModule.TransformTypeScaleReceiver();
        break;
      case CURSOR_MODE.STYLE_ONLY:
        Mixpanel.track(true, MxEvent.CURATOR_STYLE_SELECTED);
        unityContext.shortcutsModule.StyleOnlyReceiver(true);
        break;
      default:
        throw new Error('Cursor mode not supported ' + cursorMode);
    }
  };

  const toggleTransformSpaceMode = (newMode) => {
    if (typeof newMode === 'undefined') {
      const transformSpaceMode = selectTransformSpaceMode(getAppState());
      newMode =
        transformSpaceMode === TRANSFORM_SPACE_MODE.GLOBAL
          ? TRANSFORM_SPACE_MODE.LOCAL
          : TRANSFORM_SPACE_MODE.GLOBAL;
    }

    unityContext.shortcutsModule.TransformSpaceReceiver(newMode);
    // unity will trigger changing of state so we don't need to update it
    // dispatch(curatorActions.setTransformSpaceMode(newMode));
  };

  const toggleSelectedAxis = (axis) => {
    if (!canChangeSelectedAxis(undefined, { showWarnings: true })) {
      return;
    }

    const axisAvailability = selectAxisAvailability(getAppState());

    if (!axisAvailability[axis]) {
      // errorToast('It is not possible to switch to `${axis}` when 2d is activated')
      return;
    }
    dispatch(resetObjectPositionAlongAxis());
    unityContext.shortcutsModule.OnClickSelectAxisButtonReceiver(axis);
    dispatch(curatorActions.toggleSelectedAxis(axis));
  };

  const disableSelectedAxis = () => {
    const selectedAxis = selectSelectedAxis(getAppState());

    if (selectedAxis !== AXIS.ALL) {
      dispatch(resetObjectPositionAlongAxis());
      unityContext.shortcutsModule.OnClickSelectAxisButtonReceiver(selectedAxis);
      dispatch(curatorActions.toggleSelectedAxis(AXIS.ALL));
    }
  };

  const changeDimension = () => {
    const is3DMode = selectIs3DMode(getAppState());
    const sidebarSection = selectSidebarSection(getAppState());
    const switchingTo2DMode = is3DMode;

    Mixpanel.track(true, is3DMode ? MxEvent.CURATOR_2D_TURNED_ON : MxEvent.CURATOR_2D_TURNED_OFF);

    if (switchingTo2DMode) {
      dispatch(resetObjectPositionAlongAxis());
      // reset view state when we switch to 2D mode
      dispatch(setUnity2DViewMode(UNITY_2D_VIEW_MODE.TOP));
      disableSelectedAxis();
    }

    unityContext.shortcutsModule.Switch3d2DViewReceiver();
    dispatch(toggleDimension());

    if (switchingTo2DMode && sidebarSection === CURATOR_MENU_SECTION.CAMERAS) {
      dispatch(setSidebarSection(null));
    }
  };

  const snapObject = (snap) => {
    unityContext.shortcutsModule.snapObject(snap);
  };

  const removeSelection = (keyDown) => {
    unityContext.shortcutsModule.removeSelection(keyDown);
  };

  const switchToMove = () => {
    changeCursorMode(CURSOR_MODE.MOVE);
  };

  const switchToRotate = () => {
    changeCursorMode(CURSOR_MODE.ROTATE);
  };

  const switchToScale = () => {
    changeCursorMode(CURSOR_MODE.SCALE);
  };

  const switchToStyleOnly = () => {
    changeCursorMode(CURSOR_MODE.STYLE_ONLY);
  };

  const duplicateObject = () => {
    const { anyObjectSelected } = getRequiredState();
    const isStyleOnlyMode = selectIsStyleOnlyMode(getAppState());
    const canDuplicateSelectedObjects = selectCanDuplicateSelectedObjects(getAppState());

    if (isAlignDialogOpen()) return;

    if (isStyleOnlyMode) {
      errorToast("It's not possible to duplicate object in style only mode", {
        toastId: 'DUPLICATE_NOT_ALLOWED_STYLE_ONLY_MODE',
      });
      return;
    }

    if (!anyObjectSelected) {
      errorToast('Please select an object', {
        toastId: 'DUPLICATE_NOT_ALLOWED_OBJECT_NOT_SELECTED',
      });
      return;
    }

    if (!canDuplicateSelectedObjects) {
      errorToast("It's not possible to duplicate current objects selection", {
        toastId: 'DUPLICATE_NOT_POSSIBLE',
      });
      return;
    }

    const isConfiguratorPropSelected = selectIsConfiguratorPropSelected(getAppState());
    if (isConfiguratorPropSelected) {
      warningToast(`You can not duplicate configurator items.`, {
        toastId: 'CAN_NOT_DUPLICATE_CONFIGURATOR_PROP',
      });
      return;
    }

    dispatch(setDuplicatePropInProgress(true));
    clearUI();
    unityContext.shortcutsModule.DuplicatePropReceiver();
    setCuratorNotSaved();
    //TODO add property of prop name and id that was duplicated.
    Mixpanel.track(true, MxEvent.CURATOR_PROP_DUPLICATED);
  };

  const deleteObject = async () => {
    const selectedObjectList = selectSelectedObjectList(getAppState());
    const hasNotDeletableObject = selectedObjectList.find((obj) => !obj.isDeleteAble);

    if (isAlignDialogOpen()) return;

    if (hasNotDeletableObject) {
      warningToast(`You can not delete roofs, wall, and floor`, {
        toastId: 'CAN_NOT_DELETE_LAYOUT',
      });
    }
    const isConfiguratorPropSelected = selectIsConfiguratorPropSelected(getAppState());
    if (isConfiguratorPropSelected) {
      warningToast(`You can not delete configurator items.`, {
        toastId: 'CAN_NOT_DELETE_CONFIGURATOR_PROP',
      });
      return;
    }

    await cancelMapSelection();

    unityContext.shortcutsModule.DeleteObjectReceiver();
    setCuratorNotSaved();
    //Add property of prop name and id of delted prop
    Mixpanel.track(true, MxEvent.CURATOR_PROP_DELETED);
    dispatch(curatorActions.setDeletePropCompleted(true));
  };

  const replaceProp = () => {
    // resetting image search result
    dispatch(curatorActions.setImageScanSearchFile(null));

    const canReplaceProp = selectCanReplaceProp(getAppState());
    if (!canReplaceProp) {
      errorToast('Please select replaceable object');
      return;
    }

    const isLightSelected = selectIsSingleLightObjectSelected(getAppState());
    if (isLightSelected) {
      openEditSelectedLight();
      return;
    }

    dispatch(paginatedProductActions.fullResetList());
    dispatch(setReplacePropActive(true));
    dispatch(paginatedProductActions.setSearch(''));
    dispatch(setSidebarSection(CURATOR_MENU_SECTION.PRODUCTS));
  };

  const processItem = async () => {
    // Wait for the callback
    await new Promise((resolve) => {
      const interval = setInterval(() => {
        dispatch(setCuratorLoader(false));
        if (window.$isPropsReplaceCallBack === STATUS_DONE_VALUE) {
          clearInterval(interval);
          dispatch(setCuratorLoader(true));
          window.$isPropsReplaceCallBack = false;
          resolve(interval);
        }
      }, 100); // Check every 100ms if the callback has been received
    });
  };

  const doReplaceProp = async (
    newProp,
    { callbackProps = {}, callback = null, skipHistory = false } = {}
  ) => {
    const selectedProp = selectReplaceProp(getAppState());

    if (selectedProp?.length === 0) {
      errorToast('Prop to replace is missing');
      cancelReplaceProp();
      return;
    }

    dispatch(setCuratorLoader(false));
    Mixpanel.track(true, MxEvent.CURATOR_PROP_REPLACED, {
      'Prop Assign to all org': newProp?.assign_to_all_org,
      'Prop blender id': newProp?.blender_id,
      'Prop id': newProp?.id,
      'Prop is favourite': newProp?.is_favourite,
      'Prop is light available': newProp?.is_light_available,
      'Prop is Visible': newProp?.is_visible,
      'Prop asset name': newProp?.name,
      'Prop asset main name': newProp?.main_asset_name,
      'Prop owner org id': newProp?.owner_organization_details?.id,
      'Prop owner org name': newProp?.owner_organization_details?.name,
      'Old prop id': selectedProp?.map((a) => a.id).join(', '),
      'Old prop name': selectedProp?.map((a) => a.name).join(', '),
    });
    undoRedo.unityObject.startReplaceProp();

    let grouped = selectedProp?.reduce(
      (acc, curr) => {
        if (!curr.groupObjectName || curr.groupObjectName === '' || !curr.isGroupSelected) {
          acc.separate.push(curr);
        } else {
          const key = curr.groupObjectName + curr.isGroupSelected;
          if (!acc.grouped[key]) {
            acc.grouped[key] = { ...curr, childObjects: [] };
          } else {
            acc.grouped[key].childObjects.push(curr);
          }
        }
        return acc;
      },
      { grouped: {}, separate: [] }
    );

    const filterList = [...Object.values(grouped.grouped), ...grouped.separate];
    filterList?.map(async (list, index) => {
      window.$isPropsReplaceCallBack = STATUS_START_VALUE;
      dispatch(setCuratorLoader(false));
      if (index !== 0) {
        await processItem();
      }
      const isLast = index + 1 === filterList?.length;
      const selectedList = list?.childObjects ? [list, ...list?.childObjects].flat() : [list];

      let replacePropObj = {
        propId: list?.id,
        objectName: list?.objectName,
        selectedProp: selectedList,
        newProp,
        isLastPropToReplace: isLast ? true : false,
      };
      // handling replace prop for prop group
      if (callback && newProp?.is_prop_group) {
        replacePropObj.groupPropData = callbackProps?.groupPropData || {};
      }

      if (callback && newProp?.is_prop_group) {
        await unityContext.roomModule.ReplaceProp(replacePropObj);
        if (isUserOnboarding()) dispatch(setCuratorLoader(false));
        cancelReplaceProp();
        await callback?.({
          groupPropId: newProp?.id,
          unityContext,
          ...callbackProps?.groupPropData,
        });
        if (!isUserOnboarding()) dispatch(setCuratorLoader(false));
      } else {
        // setSelectedObjectList({});
        if (isUserOnboarding()) {
          await unityContext.roomModule.ReplaceProp(replacePropObj);
          dispatch(setCuratorLoader(true));
        } else {
          unityContext.roomModule.ReplaceProp(replacePropObj);
        }

        cancelReplaceProp();
        setCuratorNotSaved();
        if (!isUserOnboarding()) dispatch(setCuratorLoader(false));
      }
      if (isLast) {
        await waitForEventOnce(UnityEvent.OnReplacePropCompletedReceiver);
        if (!isRetailAutomation()) {
          const newReplaceProps = await waitForEventOnce(
            UnityEvent.GetSelectedObjectInfoOnSelection
          );
          undoRedo.unityObject.replaceProp({ newProp, skipHistory, selectedProp, newReplaceProps });
        }
        setCuratorNotSaved();
        await wait(10);
        dispatch(setCuratorLoader(true));
        undoRedo.unityObject.endReplaceProp();
      }
    });
  };

  const replacePropConfirm = (newProp, callback = null, callbackProps = {}) => {
    const onButtonClick = async () => {
      await doReplaceProp(newProp, { callbackProps, callback });
      dispatch(paginatedProductActions.setSearch(''));
    };

    if (isUserOnboarding() && step === 'SELECT_PRODUCT') {
      onButtonClick();
      return;
    }

    openInfoDialog({
      title: `Replace prop with "${newProp.name}"?`,
      buttonText: 'Yes',
      cancelButtonText: 'No',
      className: 'zIndex-3000',
      onButtonClick: onButtonClick,
      open: true,
    });
  };

  const is2DView = () => {
    return selectIs2DMode(getAppState());
  };

  const cancelReplaceProp = () => {
    dispatch(setSidebarSection(null));
    dispatch(setReplacePropActive(false));
    dispatch(paginatedProductActions.setSearch(''));
  };

  const softCancelReplaceProp = () => {
    const replacePropActive = selectReplacePropActive(getAppState());
    if (!replacePropActive) return;

    dispatch(setReplacePropActive(false));
    dispatch(paginatedProductActions.setSearch(''));
  };

  const copyMaterial = async () => {
    const canCopyMaterial = selectCanCopyMaterial(getAppState());

    if (isAlignDialogOpen()) return;

    if (!canCopyMaterial) {
      errorToast('You can not copy material of this object', {
        toastId: 'CAN_NOT_COPY_MATERIAL',
      });
      return;
    }

    const isSelectMapModeActive = selectIsSelectMapModeActive(getAppState());
    if (isSelectMapModeActive) {
      errorToast('Cannot copy material while custom map panel is open', {
        toastId: 'UNABLE_TO_COPY_MATERIAL_WHILE_MAP_OPEN',
      });
      return;
    }

    const isConfiguratorPropSelected = selectIsConfiguratorPropSelected(getAppState());
    if (isConfiguratorPropSelected) {
      warningToast(`You can not copy material from configurator items.`, {
        toastId: 'CAN_NOT_COPY_MATERIAL',
      });
      return;
    }

    dispatch(setCuratorLoader(false));
    await wait(10);
    const result = await Promise.race([
      waitForEventOnce(UnityEvent.OnMessageReceivedFromUnity),
      // TODO: we need to cancel it on error
      waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo, () => {
        unityContext.shortcutsModule.copyMaterial();
      }),
    ]);

    dispatch(setCuratorLoader(true));
    if (result?.isError) {
      return;
    }

    const data = result;

    try {
      const objectProperties = JSON.parse(data);
      const allProjectTextures = selectProjectLoadedTexture(getAppState());
      const currentTexture = allProjectTextures?.find(
        (data) => data.id == objectProperties?.changedMapsPath?.diffuseId
      );
      const textureIdCurrent = currentTexture?.id || objectProperties?.changedMapsPath?.diffuseId;
      if (textureIdCurrent) {
        let query = `id=${textureIdCurrent}&ignore_lf_default=true&per_page=20`;
        const textures = await fetchAllPages((page) => {
          return apiGetTextureList({ query: `${query}&page=${page}` });
        });
        if (textures?.results?.[0]?.is_removed) {
          errorToast('This texture is removed by your organization & cannot be copied.');
          return;
        }
      }

      await loadDefaultTextures({
        object: objectProperties,
        // objectName: selectedObject.objectName,
        materialId: objectProperties.loadedMaterialId,
      });
      dispatch(setMaterialCopied(true));
      dispatch(setCopiedObjectProperties(objectProperties));
      successToast('Material copied');
      //TODO connect with Prabhu for required properties
      Mixpanel.track(true, MxEvent.CURATOR_MATERIAL_COPIED, {
        'Material aoIntensity': objectProperties?.aoIntensity,
        'Material aoMapName': objectProperties?.aoMapName,
        'Material colorValue': objectProperties?.colorValue,
        'Material diffuseName': objectProperties?.diffuseName,
        'Material effectLightColorBounce': objectProperties?.effectLightColorBounce,
        'Material emissionIntensity': objectProperties?.emissionIntensity,
        'Material initialMetalIntensity': objectProperties?.initialMetalIntensity,
        'Material isAOInvert': objectProperties?.isAOInvert,
        'Material isAOMap': objectProperties?.isAOMap,
        'Material isAOMapChanged': objectProperties?.isAOMapChanged,
        'Material isAdvanced': objectProperties?.isAdvanced,
        'Material isColor': objectProperties?.isColor,
        'Material isCurrentMapsGenerated': objectProperties?.isCurrentMapsGenerated,
        'Material isCustomAOMap': objectProperties?.isCustomAOMap,
        'Material isCustomMetallicMap': objectProperties?.isCustomMetallicMap,
        'Material isCustomNormalMap': objectProperties?.isCustomNormalMap,
        'Material isCustomRoughnessMap': objectProperties?.isCustomRoughnessMap,
        'Material isCustomTransparencyMap': objectProperties?.isCustomTransparencyMap,
        'Material isInitialMaterialChanged': objectProperties?.isInitialMaterialChanged,
        'Material isMetallicMap': objectProperties?.isMetallicMap,
        'Material isMetallicMapChanged': objectProperties?.isMetallicMapChanged,
        'Material isNormal': objectProperties?.isNormal,
        'Material isNormalInvert': objectProperties?.isNormalInvert,
        'Material isNormalMapChanged': objectProperties?.isNormalMapChanged,
        'Material isRoughnessInvert': objectProperties?.isRoughnessInvert,
        'Material isRoughnessMap': objectProperties?.isRoughnessMap,
        'Material isRoughnessMapChanged': objectProperties?.isRoughnessMapChanged,
        'Material isSavedPreset': objectProperties?.isSavedPreset,
        'Material isTexture': objectProperties?.isTexture,
        'Material isTextureChanged': objectProperties?.isTextureChanged,
        'Material isTexturefromMaterialPreset': objectProperties?.isTexturefromMaterialPreset,
        'Material isTransparency': objectProperties?.isTransparency,
        'Material isTransparencyFromAlbedo': objectProperties?.isTransparencyFromAlbedo,
        'Material isTransparencyInvert': objectProperties?.isTransparencyInvert,
        'Material isTransparencyMapChanged': objectProperties?.isTransparencyMapChanged,
        'Material loadedMaterialId': objectProperties?.loadedMaterialId,
        'Material loadedMaterialPath': objectProperties?.loadedMaterialPath,
        'Material materialId': objectProperties?.materialId,
        'Material materialName': objectProperties?.materialName,
        'Material materialTextureId': objectProperties?.materialTextureId,
        'Material materialTextureName': objectProperties?.materialTextureName,
        'Material materialTexturePath': objectProperties?.materialTexturePath,
        'Material materialType': objectProperties?.materialType,
        'Material metalIntensity': objectProperties?.metalIntensity,
        'Material metallicMapName': objectProperties?.metallicMapName,
        'Material metallicVersion': objectProperties?.metallicVersion,
        'Material normalIntensity': objectProperties?.normalIntensity,
        'Material normalMapName': objectProperties?.normalMapName,
        'Material normalVersion': objectProperties?.normalVersion,
        'Material objName': objectProperties?.objName,
        'Material objectName': objectProperties?.objectName,
        'Material roughnessIntensity': objectProperties?.roughnessIntensity,
        'Material roughnessMapName': objectProperties?.roughnessMapName,
        'Material roughnessVersion': objectProperties?.roughnessVersion,
        'Material savedPresetId': objectProperties?.savedPresetId,
        'Material skuId': objectProperties?.skuId,
        'Material textureId': objectProperties?.textureId,
        'Material transparencyIntensity': objectProperties?.transparencyIntensity,
        'Material transparencyMapName': objectProperties?.transparencyMapName,
        'Material transparencyVersion': objectProperties?.transparencyVersion,
        'Material useGeneralTiling': objectProperties?.useGeneralTiling,
        'Material xMatOffset': objectProperties?.xMatOffset,
        'Material xMatTiling': objectProperties?.xMatTiling,
        'Material yMatOffset': objectProperties?.yMatOffset,
        'Material yMatTiling': objectProperties?.yMatTiling,
      });
    } catch (error) {
      // TODO: sentry log here
      console.error(error);
      errorToast('Error, unable to copy material');
    }
  };

  const selectObjectWithSameMaterial = () => {
    const anyObjectSelected = selectIsAnyObjectSelected(getAppState());
    
    if (!anyObjectSelected) {
      errorToast('Please select an object first', {
        toastId: 'NO_OBJECT_SELECTED',
      });
      return;
    }

    unityContext.materialModule?.SelectObjectOnTheBasisOfMaterialProperty();
  };

  const breakMaterial = () => {
    const anyObjectSelected = selectIsAnyObjectSelected(getAppState());
    
    if (!anyObjectSelected) {
      errorToast('Please select an object first', {
        toastId: 'NO_OBJECT_SELECTED',
      });
      return;
    }

    unityContext.materialModule?.BreakMaterialOfSelectedObjects();
    //successToast('Material instance broken');
  };

  const pasteMaterial = async (checkGroupPropsAreSelected = true) => {
    const isMaterialCopied = selectIsMaterialCopied(getAppState());
    const isPasteMaterialLoading = selectPasteMaterialLoading(getAppState());

    if (isPasteMaterialLoading && isMattressBuilderPage()) return;

    if (!isMaterialCopied) {
      errorToast('Please copy a material first');
      return;
    }

    if (selectIsSelectMapModeActive(getAppState())) {
      errorToast('You can not paste material while custom map panel is oen', {
        toastId: 'UNABLE_PASTE_MATERIAL_WHILE_CUSTOM_MAP_OPEN',
      });
      return;
    }

    // check if all objects are styleable
    const objectList = selectSelectedObjectList(getAppState());

    if (objectList.length === 0) {
      errorToast('Please select an object', {
        toastId: 'OBJECT_SELECTION_MISSING',
      });
      return;
    }

    if (objectList.length > 1) {
      const allSelectedObjectsStyleable = selectAllSelectedObjectsStyleable(getAppState());
      if (!allSelectedObjectsStyleable) {
        // errorToast(`It's not possible to style current objects selection`, { toastId: 'NOT_ALL_OBJECTS_STYLEABLE' });
        errorToast('This object is not customisable', {
          toastId: 'NOT_ALL_OBJECTS_STYLEABLE',
        });
        return;
      }
    }

    setPasteMaterialLoading(true);

    // First check if there is an error from unity
    const firstResult = await Promise.race([
      waitForEventOnce(UnityEvent.OnMessageReceivedFromUnity),
      Promise.resolve({ isError: false }),
    ]);

    // If there is an error from unity return
    if (firstResult?.isError) {
      setPasteMaterialLoading(false);
      return;
    }

    // If there is no error then proceed for further callbacks
    if (!firstResult?.isError) {
      const pasteMaterialPossibleReceiver = waitForEventOnce(
        UnityEvent.pasteMaterialPossibleReceiver
      );
      const allGroupPropsAreNotSelected = waitForEventOnce(UnityEvent.AllGroupPropsAreNotSelected);
      unityContext.materialModule.OnSelectPasteMaterial();
      const promises = [
        // TODO: we need to cancel it on error
        pasteMaterialPossibleReceiver,
      ];
      if (isMattressBuilderPage()) {
        promises.push(allGroupPropsAreNotSelected);
      }
      const result = checkGroupPropsAreSelected ? await Promise.race(promises) : { allGroupPropsAreNotSelected: false };
      if (result?.allGroupPropsAreNotSelected) {
        setPasteMaterialLoading(false);
        openInfoDialog({
          title:
            'This will apply material to all props in the group. Are you sure you want to continue?',
          cancelButtonText: 'Cancel',
          buttonText: 'Confirm',
          onButtonClick: () => {
            dispatch(paginatedProductActions.resetProgress());
            initiateProductBuilderProgressLoading({
              progressTimes: [0, 0.1, 0.15, 0.2, 0.249],
              totalProgress: 0.25,
            });
            pasteMaterial(false);
          },
        });
        return;
      }
    }

    setCuratorNotSaved({ saveTempData: false });
    const copiedObject = selectCopiedObjectProperties(getAppState());

    if (copiedObject.loadedMaterialId) {
      // paste material from collection
      await wait(20); // timeout to let react update ui with loader;
      unityContext.shortcutsModule.pasteMaterial();
      setCuratorNotSaved();
    } else {
      // paste default material
      const { objectName } = copiedObject;

      // TODO: go through all default texture names here instead of object name
      // const defaultTextureList = await getDefaultTextureList({ objectName });

      const defaultTextureNameKeys = Object.values(TEXTURE_NAME_KEY);

      // TODO: make sure that uniqueness is handled correctly -> if one default texture applied to 2 custom maps we will try to upload both of them at the same time
      try {
        const textureList = await Promise.all(
          defaultTextureNameKeys.map(async (textureNameKey) => {
            const textureName = copiedObject[textureNameKey];
            if (!textureName) return;

            const textureType = TEXTURE_NAME_KEY__TEXTURE_MAP[textureNameKey];
            const tilingType = TEXTURE_MAP_TO_TILING_TYPE[textureType];
            const mapType = TILING_MAP[tilingType];
            const idKey = CHANGED_MAP_IDS__TEXTURE_MAP[textureType];

            if (copiedObject.changedMapsPath[idKey]) return;
            // { file, textureName,  }
            const defaultTexture = await getDefaultTextureFromIdb({
              textureName,
            });
            const { file } = defaultTexture;

            const defaultTextureDataList = await apiGetDefaultTexture({
              name: textureName,
            });
            const defaultTextureData = defaultTextureDataList?.results?.[0];

            let texture;
            if (defaultTextureData) {
              texture = await updateDbTexture(defaultTextureData);
            } else {
              const uploadedTexture = await apiAddDefaultTexture({
                name: textureName,
                file,
              });

              if (!uploadedTexture?.data?.id) {
                setPasteMaterialLoading(false);
                return;
              }

              texture = await updateDbTexture(uploadedTexture.data);
            }

            return {
              mapType,
              textureId: texture.id,
              textureName: texture.name,
              textureVersion: texture.version,
            };
          })
        );

        const filteredTextureList = textureList.filter(Boolean);

        await wait(20); // timeout to let react update ui with loader;
        unityContext.shortcutsModule.pasteMaterial(filteredTextureList);
        setCuratorNotSaved();
        //TODO consult with praabhu for required properties
        Mixpanel.track(true, MxEvent.CURATOR_MATERIAL_PASTED, {
          'Texture pasted on': objectList,
          'Material aoIntensity': copiedObject?.aoIntensity,
          'Material aoMapName': copiedObject?.aoMapName,
          'Material colorValue': copiedObject?.colorValue,
          'Material diffuseName': copiedObject?.diffuseName,
          'Material effectLightColorBounce': copiedObject?.effectLightColorBounce,
          'Material emissionIntensity': copiedObject?.emissionIntensity,
          'Material initialMetalIntensity': copiedObject?.initialMetalIntensity,
          'Material isAOInvert': copiedObject?.isAOInvert,
          'Material isAOMap': copiedObject?.isAOMap,
          'Material isAOMapChanged': copiedObject?.isAOMapChanged,
          'Material isAdvanced': copiedObject?.isAdvanced,
          'Material isColor': copiedObject?.isColor,
          'Material isCurrentMapsGenerated': copiedObject?.isCurrentMapsGenerated,
          'Material isCustomAOMap': copiedObject?.isCustomAOMap,
          'Material isCustomMetallicMap': copiedObject?.isCustomMetallicMap,
          'Material isCustomNormalMap': copiedObject?.isCustomNormalMap,
          'Material isCustomRoughnessMap': copiedObject?.isCustomRoughnessMap,
          'Material isCustomTransparencyMap': copiedObject?.isCustomTransparencyMap,
          'Material isInitialMaterialChanged': copiedObject?.isInitialMaterialChanged,
          'Material isMetallicMap': copiedObject?.isMetallicMap,
          'Material isMetallicMapChanged': copiedObject?.isMetallicMapChanged,
          'Material isNormal': copiedObject?.isNormal,
          'Material isNormalInvert': copiedObject?.isNormalInvert,
          'Material isNormalMapChanged': copiedObject?.isNormalMapChanged,
          'Material isRoughnessInvert': copiedObject?.isRoughnessInvert,
          'Material isRoughnessMap': copiedObject?.isRoughnessMap,
          'Material isRoughnessMapChanged': copiedObject?.isRoughnessMapChanged,
          'Material isSavedPreset': copiedObject?.isSavedPreset,
          'Material isTexture': copiedObject?.isTexture,
          'Material isTextureChanged': copiedObject?.isTextureChanged,
          'Material isTexturefromMaterialPreset': copiedObject?.isTexturefromMaterialPreset,
          'Material isTransparency': copiedObject?.isTransparency,
          'Material isTransparencyFromAlbedo': copiedObject?.isTransparencyFromAlbedo,
          'Material isTransparencyInvert': copiedObject?.isTransparencyInvert,
          'Material isTransparencyMapChanged': copiedObject?.isTransparencyMapChanged,
          'Material loadedMaterialId': copiedObject?.loadedMaterialId,
          'Material loadedMaterialPath': copiedObject?.loadedMaterialPath,
          'Material materialId': copiedObject?.materialId,
          'Material materialName': copiedObject?.materialName,
          'Material materialTextureId': copiedObject?.materialTextureId,
          'Material materialTextureName': copiedObject?.materialTextureName,
          'Material materialTexturePath': copiedObject?.materialTexturePath,
          'Material materialType': copiedObject?.materialType,
          'Material metalIntensity': copiedObject?.metalIntensity,
          'Material metallicMapName': copiedObject?.metallicMapName,
          'Material metallicVersion': copiedObject?.metallicVersion,
          'Material normalIntensity': copiedObject?.normalIntensity,
          'Material normalMapName': copiedObject?.normalMapName,
          'Material normalVersion': copiedObject?.normalVersion,
          'Material objName': copiedObject?.objName,
          'Material objectName': copiedObject?.objectName,
          'Material roughnessIntensity': copiedObject?.roughnessIntensity,
          'Material roughnessMapName': copiedObject?.roughnessMapName,
          'Material roughnessVersion': copiedObject?.roughnessVersion,
          'Material savedPresetId': copiedObject?.savedPresetId,
          'Material skuId': copiedObject?.skuId,
          'Material textureId': copiedObject?.textureId,
          'Material transparencyIntensity': copiedObject?.transparencyIntensity,
          'Material transparencyMapName': copiedObject?.transparencyMapName,
          'Material transparencyVersion': copiedObject?.transparencyVersion,
          'Material useGeneralTiling': copiedObject?.useGeneralTiling,
          'Material xMatOffset': copiedObject?.xMatOffset,
          'Material xMatTiling': copiedObject?.xMatTiling,
          'Material yMatOffset': copiedObject?.yMatOffset,
          'Material yMatTiling': copiedObject?.yMatTiling,
        });
      } catch (e) {
        //captureException(e);
        console.error(e);
        setPasteMaterialLoading(false);
        errorToast('Error happened while pasting material. LF_889294k');
      }
    }
  };

  const alignObject = async () => {
    const isSelectMapModeActive = selectIsSelectMapModeActive(getAppState());
    if (isSelectMapModeActive) {
      errorToast('Cannot align object while custom map panel is open', {
        toastId: 'UNABLE_TO_ALIGN_OBJECT_WHILE_MAP_OPEN',
      });
      return;
    }

    const isConfiguratorPropSelected = selectIsConfiguratorPropSelected(getAppState());
    if (isConfiguratorPropSelected) {
      warningToast(`You can not align object from configurator items.`, {
        toastId: 'CAN_NOT_ALIGN_OBJECT',
      });
      return;
    }

    try {
      await wait(10);
      unityContext.alignmentModule.alignObjectUnity();
      dispatch(setInfoWarningPopupMessage('Choose a reference object for alignment.'));
      dispatch(setShowInfoWarningPopup(true));
    } catch (err) {
      console.log(err, 'error');
    }
  };

  const update2DViewMode = (viewMode) => {
    if (!is2DView()) {
      changeDimension();
    }

    // switch between 'bottom' | 'left' | 'right' | 'top'  in 2d mode
    const selectedAxis = selectSelectedAxis(getAppState());
    // toggleSelectedAxis(selectedAxis);
    disableSelectedAxis();
    dispatch(setUnity2DViewMode(viewMode));
    unityContext.shortcutsModule.OnSetup2DViewsReceiver(viewMode);
  };

  const closeProject = (combinedWithConfiguratorId) => {
    const curatorInitialized = selectCuratorInitialized(getAppState());
    const isBuilder = type === 'builder';
    const builderUrl = getMattressBuilderPath();

    if (!curatorInitialized) {
      // curator still loading no need for save popup
      navigate(isBuilder ? builderUrl : getProjectsPath(isGuestLogin));
    }

    openInfoDialog({
      title: 'Quit Project',
      description: combinedWithConfiguratorId
        ? 'Do you want to update in configurator?'
        : isBuilder
        ? 'Do you really want to quit the current project?'
        : `Do you want to save your changes?`,
      cancelButtonText: 'No',
      buttonText: 'Yes',
      className: 'zIndex-3000',
      onCancelClick: () => {
        if (isBuilder) {
          return;
        }
        navigate(getProjectsPath(isGuestLogin));
      },
      onButtonClick: async () => {
        Mixpanel.track(true, MxEvent.CURATOR_CLOSED);
        if (isGuestLogin) {
          navigate(isBuilder ? builderUrl : getProjectsPath(isGuestLogin));
          return;
        }
        if (isBuilder) {
          navigate(builderUrl);
          return;
        }
        if (combinedWithConfiguratorId) {
          dispatch(setClickedUpdateConfigurator(true));
          dispatch(setCuratorLoader(false));
          await wait(500);
          await unityContext.roomModule.GetLoadedLifeStyleInfoReceiver();
        } else {
          dispatch(setSaveProjectMode(SAVE_PROJECT_MODE.CLOSE_CURATOR, isGuestLogin));
          dispatch(setSaveProjectDialogOpen(true));
        }
      },
    });
  };

  const saveProject = () => {
    if (!checkIfMemberHaveEditorAccess()) return;

    const projectOwner = selectProjectOwner(getAppState());
    const isOwner =
      projectOwner?.owner_organization === currentUser.organization &&
      projectOwner?.id === currentUser.user.id;
    if (!isOwner) {
      saveProjectAsNew();
      return;
    }

    dispatch(setSaveProjectMode(SAVE_PROJECT_MODE.SAVE));
    saveProjectActions.saveProject();
    // dispatch(setSaveProjectDialogOpen(true));
    Mixpanel.track(true, MxEvent.CURATOR_ROOM_SAVE);
  };

  const saveProjectAsNew = () => {
    dispatch(setSaveProjectMode(SAVE_PROJECT_MODE.NEW));
    dispatch(setSaveProjectDialogOpen(true));
  };

  const focusObject = () => {
    unityContext.shortcutsModule.focusObject();
  };

  const toggleStyleSection = (name, open) => {
    const valid = validateStyleable();
    if (!valid) return;

    const loading = selectApplyTextureInProgress(getAppState());
    if (loading) {
      errorToast('Please wait, previous texture is still in progress', {
        toastId: 'TEXTURE_APPLY_IN_PROGRESS_TAB_SWITCH_HOTKEY',
      });
      return;
    }

    const { activeTab } = curatorStylesSelector(getAppState());
    const sidebarActiveSection = curatorSelector(getAppState()).sidebarSection;

    if (activeTab !== name && sidebarActiveSection === CURATOR_MENU_SECTION.STYLE) {
      // in this case we just need to switch tabs
      dispatch(setActiveTab(name));
      return;
    }

    if (typeof open === 'boolean') {
      open ? openSidebarSection(CURATOR_MENU_SECTION.STYLE) : closeSidebar();
    } else {
      toggleSidebarSection(CURATOR_MENU_SECTION.STYLE);
    }
    dispatch(setActiveTab(name));
  };

  const openEditSelectedLight = () => {
    const selectedLightObject = selectSelectedLightObject(getAppState());
    if (!selectedLightObject) {
      errorToast('Please select a light');
      return;
    }

    dispatch(setSidebarSection(CURATOR_MENU_SECTION.LIGHT));
    dispatch(curatorLight.setSelectedLightId(selectedLightObject.id));
    dispatch(curatorLight.setActiveTab(curatorLight.TAB_NAME.INDOOR));
  };

  const toggleProperties = () => {
    const isLightSelected = selectIsSingleLightObjectSelected(getAppState());
    const selectedObjectList = selectSelectedObjectList(getAppState());

    if (selectedObjectList.length > 1) {
      errorToast(`It's not possible to open object details for multiple selected items`);
      return;
    }

    if (isLightSelected) {
      openEditSelectedLight();
    } else {
      toggleStyleSection(TAB_NAME.PROPERTIES);
    }
  };

  const toggleTexture = (open) => {
    toggleStyleSection(TAB_NAME.TEXTURES, open);
  };

  const toggleMaterial = () => {
    toggleStyleSection(TAB_NAME.MATERIALS);
  };

  const toggleColor = () => {
    toggleStyleSection(TAB_NAME.COLORS);
  };

  const toggleImages = () => {
    toggleSidebarSection(CURATOR_MENU_SECTION.RENDERS_AND_PREVIEWS);
  };

  const toggleHighlightSelected = () => {
    const highlightSelected = selectHighlightSelected(getAppState());
    const newValue = !highlightSelected;
    unityContext.shortcutsModule.toggleHighlightSelected(newValue);
    dispatch(setHighlightSelected(newValue));
  };

  const toggleDimensions = () => {
    const dimensions = selectShowDimensions(getAppState());
    const measureUnit = selectMeasureUnit(getAppState());
    const newValue = !dimensions;

    unityContext.shortcutsModule.toggleDimensions(measureUnit.id - 1);
    dispatch(setShowDimensions(newValue));
  };

  const toggleLightsVisibility = () => {
    const lightsVisibility = selectLightsVisibility(getAppState());
    const newValue = !lightsVisibility;
    unityContext.shortcutsModule.toggleLightsVisibility(newValue);
    dispatch(setLightsVisibility(newValue));
  };

  const toggleCameraSafeMode = () => {
    const cameraSafeMode = selectCameraSafeModeEnabled(getAppState());
    dispatch(setGlobalSafeCameraFlag(!cameraSafeMode));
  };

  const toggleGridView = () => {
    const gridView = selectGridViewEnabled(getAppState());
    dispatch(setGridViewFlag(!gridView));
  };

  const focusEverything = () => {
    unityContext.shortcutsModule.focusEverything();
  };

  const deselectAll = () => {
    unityContext.shortcutsModule.deselectAll();
  };

  const toggleShortcuts = () => {
    const open = selectPopupOpen(getAppState());
    dispatch(setPopupOpen(!open));
    dispatch(setSidebarSection(null));
  };

  const toggleRotationSnapping = () => {
    const active = selectRotationSnappingActive(getAppState());
    const newActive = !active;
    dispatch(curatorSnappingActions.setSnappingActive(newActive));

    unityContext.shortcutsModule.SnapRotationKey(newActive);

    if (newActive) {
      const value = selectRotationSnappingValue(getAppState());
      unityContext.shortcutsModule.SetSnapRotationValue(value);
    }
  };

  const groupSelectedObject = () => {
    unityContext.shortcutsModule.GroupSelectedObject();
  };

  const unGroupSelectedObject = () => {
    unityContext.shortcutsModule.UnGroupSelectedObject();
  };

  const selectPreviousSibilingChild = () => {
    unityContext.shortcutsModule.SelectPreviousSibilingChild();
  };

  const selectNextSibilingChild = () => {
    unityContext.shortcutsModule.SelectNextSibilingChild();
  };

  const resetSelectedPropTransformReceiver = () => {
    unityContext.shortcutsModule.ResetSelectedPropTransformReceiver();
  };

  const resetSelectedPropPositionReceiver = () => {
    unityContext.shortcutsModule.ResetSelectedPropPositionReceiver();
  };

  const toggleDebug = () => {
    console.log(unityContext, 'unityContext');
    unityContext.mainController.ToggleDebuggerModeReciever(true);
  };

  return {
    changeCursorMode,
    toggleTransformSpaceMode,
    toggleSelectedAxis,
    changeDimension,
    switchToMove,
    switchToRotate,
    switchToScale,
    switchToStyleOnly,
    duplicateObject,
    deleteObject,
    copyMaterial,
    pasteMaterial,
    selectObjectWithSameMaterial,
    breakMaterial,
    update2DViewMode,
    closeProject,
    saveProject,
    saveProjectAsNew,
    focusObject,
    toggleProperties,
    toggleTexture,
    toggleMaterial,
    toggleColor,
    toggleImages,
    renderPreviewPopup,
    disableSelectedAxis,
    openEditSelectedLight,
    doReplaceProp,
    toggleHighlightSelected,
    toggleDimensions,
    toggleLightsVisibility,
    toggleCameraSafeMode,
    toggleGridView,
    focusEverything,
    deselectAll,
    toggleShortcuts,
    replaceProp,
    replacePropConfirm,
    cancelReplaceProp,
    softCancelReplaceProp,
    snapObject,
    toggleRotationSnapping,
    removeSelection,
    groupSelectedObject,
    unGroupSelectedObject,
    selectPreviousSibilingChild,
    selectNextSibilingChild,
    resetSelectedPropTransformReceiver,
    resetSelectedPropPositionReceiver,
    toggleDebug,
    alignObject,
    undo: undoRedo.undo,
    redo: undoRedo.redo,
  };
};
